import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { CreateControlTaskType } from '../../../types'

export const collection = 'controlTasks'

export const schema = new schemas.Entity(collection)

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, { caseId, controlTaskId, body }: CreateControlTaskType) =>
    callApi(
      `${apiBase}/cases/${caseId}/controlTasks/${controlTaskId}/action`,
      schema,
      {
        method: 'POST',
        body,
      }
    )
